import React from 'react'
import CouponSetup from '../components/Couponlist/CouponSetup'

function Setup() {
  return (
    <CouponSetup/>
  )
}

export default Setup